<button
  class="btn btn-ternary btn-icon"
  [ngbPopover]="confirmRemoveContent"
  #popOver="ngbPopover"
  [popoverClass]="'delete-button-popover'"
  [placement]="popoverPlacement"
  [ngbTooltip]="'common.delete_tooltip' | cxTranslate"
  [attr.aria-label]="'common.delete_tooltip' | cxTranslate"
>
  <i nz-icon nzType="delete"></i>
</button>
<ng-template #confirmRemoveContent>
  <div class="d-flex flex-column" role="region" [attr.aria-label]="'common.delete_heading' | cxTranslate">
    <div class="d-flex justify-content-between border-bottom p-3">
      <h1 class="h5">{{ 'common.delete_action' | cxTranslate }}</h1>
      <button (click)="popOver.close()" class="close" [attr.aria-label]="'common.close_action' | cxTranslate">
        <i nz-icon pyIconThemeReverse nzType="close-circle" nzTheme="outline"></i>
      </button>
    </div>
    <div class="d-flex flex-column p-3">
      <button class="btn btn-danger mb-2" (click)="confirmDeletion.emit()">
        {{ 'common.yesAndRemove_action' | cxTranslate }}
      </button>
      <button class="btn btn-plain-secondary" (click)="popOver.close()">
        {{ 'common.noAndCancel_action' | cxTranslate }}
      </button>
    </div>
  </div>
</ng-template>
